import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48,
    keepPathColor: true
}

/**
 * Stateless function representing an inactive notice icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <NoticeInactiveIcon width={12} />
 */
const NoticeInactiveIcon = props => (
    <SvgIcon {...props}>
        <path
            fill="#fff"
            d={`M22 7.68a3.67 3.67 0 0 0-3.85 3.45S19 22 19.11 23.57A2.73 2.73
        0 0 0 22 26.16a2.71 2.71 0 0 0 2.89-2.59c.11-1.59 1-12.44 1-12.44A3.67 3.67 0 0 0 22
        7.68zM22 28.6a3.85 3.85 0 1 0 3.85 3.85A3.85 3.85 0 0 0 22 28.6z`}
        />
        <path
            fill="#e3e6e7"
            d={`M42.83 28.83L28.41 4.22C26.92 1.54 24.58 0 22 0s-4.92 1.54-6.41
        4.22L1.17 28.77a7.61 7.61 0 0 0-.25 7.68A8.07 8.07 0 0 0 8 40h28c3 0 5.76-1.26 7.08-3.5a7.61
        7.61 0 0 0-.25-7.67zM22 36.3a3.85 3.85 0 1 1 3.85-3.85A3.85 3.85 0 0 1 22 36.3zm2.89-12.73A2.71
        2.71 0 0 1 22 26.16a2.73 2.73 0 0 1-2.89-2.59c-.12-1.57-1-12.44-1-12.44A3.67 3.67 0 0 1 22
        7.68a3.67 3.67 0 0 1 3.85 3.45S25 22 24.89 23.57z`}
        />
    </SvgIcon>
)

NoticeInactiveIcon.defaultProps = defaultProps

export { NoticeInactiveIcon }
